import React from 'react';
import './Print.css';
import { useSelector, useDispatch } from 'react-redux';
import { dateFormat } from '../utils/Utils';

export default function Print({
  customerName,
  customerNumber,
  address,
  invoiceId,
  orderDate,
  advance,
  amount,
  items,
  discount,
  // specialPrice
}) {
  const productList = useSelector((state) => state.productList);
  const { products } = productList;

  const productName = (proId) => {
    let data = products.filter((data) => data._id === proId);

    return data[0].name;
  };

  console.log(orderDate)


  return (
    <div class="page-content container">
      <div class="container px-0">
        <div class="row mt-4">
          <div class="col-12 col-lg-12">
            <div class="row">
              <div class="col-12">
                <div class="text-center text-150">
                  <i class="fa fa-book fa-2x text-success-m2 mr-1"></i>
                  <span class="text-default-d3">
                    <img src="/logo.png" />
                    <div style={{ fontSize: '10px' }}>
                      Mini Road, Changuvetty - Kottakkal
                    </div>
                  </span>
                </div>
              </div>
            </div>

            <hr class="row brc-default-l1 mx-n1 mb-4" />

            <div class="row">
              <div class="col-sm-6">
                <div>
                  <span class="text-sm text-grey-m2 align-middle">Name :</span>
                  <span class="text-500 text-80 text-blue align-middle">
                    &nbsp; {customerName}
                  </span>
                </div>
                <div class="text-grey-m2">
                  <div class="my-1">{address}</div>

                  <div class="my-1">
                    <i class="fa fa-phone fa-flip-horizontal text-secondary"></i>{' '}
                    <b class="text-600">{customerNumber}</b>
                  </div>
                </div>
              </div>

              <div class="text-95 col-sm-6 align-self-start d-sm-flex justify-content-end">
                <hr class="d-sm-none" />
                <div class="text-grey-m2">
                  <div class="mt-1 mb-2 text-secondary-m1 text-600 text-125">
                    Invoice
                  </div>

                  <div class="my-2">
                    <i class="fa fa-circle text-blue-m2 text-xs mr-1"></i>{' '}
                    <span class="text-600 text-90">ID:</span>{' '}
                    {`ADC_${invoiceId}`}
                  </div>

                  <div class="my-2">
                    <i class="fa fa-circle text-blue-m2 text-xs mr-1"></i>{' '}
                    <span class="text-600 text-90">Issue Date:</span>{' '}
                    {dateFormat(orderDate)}
                  </div>
                  {amount - advance === 0 ? (
                    <div class="my-2">
                      <i class="fa fa-circle text-blue-m2 text-xs mr-1"></i>{' '}
                      <span class="text-600 text-90">Status:</span>{' '}
                      <span class="badge badge-success badge-pill px-25">
                        Paid
                      </span>
                    </div>
                  ) : (
                    <div class="my-2">
                      <i class="fa fa-circle text-blue-m2 text-xs mr-1"></i>{' '}
                      <span class="text-600 text-90">Status:</span>{' '}
                      <span class="badge badge-warning badge-pill px-25">
                        Ordered
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div class="mt-4">
              <div class="row text-600 text-white bgc-default-tp1 py-25">
                <div class="d-none d-sm-block col-1">#</div>
                <div class="col-9 col-sm-5">Items</div>
                <div class="d-none d-sm-block col-4 col-sm-2">Qty</div>
                <div class="d-none d-sm-block col-sm-2">Days</div>
                <div class="col-2">Amount</div>
              </div>
              <div class="text-95 text-secondary-d3">
                {items?.map((data) => (
                  <div class="row mb-2 mb-sm-0 py-25">
                    <div class="d-none d-sm-block col-1">1</div>
                    <div class="col-9 col-sm-5">
                      {productName(data.product)}
                    </div>
                    <div class="d-none d-sm-block col-2">{data?.qnty}</div>
                    <div class="d-none d-sm-block col-2">{data?.days}</div>

                    <div class="col-2 text-secondary-d2">₹ {amount} </div>
                  </div>
                ))}
              </div>

              <div class="row border-b-2 brc-default-l2"></div>

              <div class="row mt-3">
                {' '}
                <div class="col-12 col-sm-7 text-grey-d2 text-95 mt-2 mt-lg-0">
                  &nbsp;
                </div>
                <div class="col-12 col-sm-5 text-grey text-90 order-first order-sm-last">
                  <div class="row my-2">
                    <div class="col-7 text-right">SubTotal</div>
                    <div class="col-5">
                      <span class="text-90 text-secondary-d1">₹ {amount}</span>
                    </div>
                  </div>
                  {/* <div class="row my-2">
                    <div class="col-7 text-right">Special Price</div>
                    <div class="col-5">
                      <span class="text-90 text-secondary-d1">₹ {specialPrice}</span>
                    </div>
                  </div> */}

                  <div class="row my-2">
                    <div class="col-7 text-right">Advance</div>
                    <div class="col-5">
                      <span class="text-90 text-secondary-d1">₹ {advance}</span>
                    </div>
                  </div>
                  <div class="row my-2  ">
                    <div class="col-7 text-right">Discount</div>
                    <div class="col-5">
                      <span class="text-100 text-success-d3 opacity-2">
                        ₹ {discount}
                      </span>
                    </div>
                  </div>
                  <div class="row my-2 align-items-center bgc-primary-l3 p-2">
                    <div class="col-7 text-right text-600">Balance</div>
                    <div class="col-5">
                      <span class="text-100 text-success-d3 opacity-2 text-600">
                        ₹ {amount - (parseInt(advance) + parseInt(discount))}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <hr />

              <div>
                <span class="text-secondary-d1 text-105">
                  Terms & Conditions
                </span>
              </div>
              <div>
                <span
                  class="text-secondary   "
                  style={{ fontSize: '8px', lineHeight: '-100px' }}
                >
                  * It only issue or dagmage is lound in the returned product
                  the client should give additional expenditure
                </span>
              </div>
              <div>
                <span
                  class="text-secondary   "
                  style={{ fontSize: '8px', lineHeight: 'normal' }}
                >
                  * data lost by any technical issue we will not take the
                  responsibility
                </span>
              </div>
              <div>
                <span
                  class="text-secondary   "
                  style={{ fontSize: '8px', lineHeight: 'normal' }}
                >
                  * in case Returning time will extend the customer should
                  inform the office staff other wise castomer shoald pay an
                  extra charge
                </span>
              </div>
              <div>
                <span
                  class="text-secondary   "
                  style={{ fontSize: '8px', lineHeight: 'normal' }}
                >
                  * should check your product completely be fore leaving the
                  Shop and the damages after leaving the shop we will not take
                  responsibility
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
